import {graphql} from "gatsby";
import React, {useEffect} from "react";
import LayoutWithoutMenu from "../components/LayoutWithoutMenu";
import useTranslateOrDefault from "../hooks/useTranslateOrDefault";
import FeedbackLink from "../components/FeedbackLink";

/**
 * Template to display any doc page.
 */
export default function SinglePage({data}) {
    const post = data.markdownRemark
    const appTitle: string = useTranslateOrDefault("app-title", "docs.cloudogu.com");
    const pageNameKey = `breadcrumb-text-${post?.fields?.delocalizedSlug.replace(/\//g, '')}`;
    const pageTitle: string = useTranslateOrDefault(pageNameKey, pageNameKey);

    useEffect(() => {
        document.title = `${pageTitle ?? "-"} | ${appTitle}`
    });

    return (
        <LayoutWithoutMenu
            location={[pageTitle]}
            frontmatter={post?.frontmatter}
            delocalizedSlug={post?.fields?.delocalizedSlug}
            toc={
                <div>
                    <div dangerouslySetInnerHTML={{__html: post?.tableOfContents}}/>
                </div>
            }
            content={
                <div>
                    <div dangerouslySetInnerHTML={{__html: post?.html}}/>
                    <FeedbackLink link={data.site.siteMetadata.feedbackForumUrl}/>
                </div>
            }
        />
    )
};

export const query = graphql`
query($slug: String!, $locale: String!) {
  markdownRemark(fields: {delocalizedSlug: {eq: $slug}, locale: {eq: $locale}}) {
    html
    frontmatter {
      title
      canonical
    }
    fields {
      folders
      element
      slug
      delocalizedSlug
      title
    }
    tableOfContents(
        absolute: true
        pathToSlugField: "fields.localizedSlug"
    )
  }
  site {
    siteMetadata {
        feedbackForumUrl
    }
  }
}
`
